import { useMemo, useState } from "react";
import { ChartFilterBar, LineChartCard } from "../../../components/Charts";
import type { FilterDefinition, FilterValues } from "../../../types/chartFilters";
import type { FilterOnChange } from "../../../components/Charts/ChartFilterBar";
import { makeYearRangeFilter } from "../common/sharedFilterDefs";
import { useP3Data, type P3FilterValues } from "./useP3ChartData";
import CompareButton from "../common/CompareButton";

const DEFAULT_FILTERS: P3FilterValues = {
  yearRange: undefined,
};

const P3ChartSection = () => {
  const [filters, setFilters] = useState<P3FilterValues>(DEFAULT_FILTERS);
  const { chartData, lines, yearRange, loading, error } = useP3Data(filters);

  const filterDefs: FilterDefinition[] = useMemo(
    () => [makeYearRangeFilter(yearRange[0], yearRange[1])],
    [yearRange]
  );

  const handleFilterChange: FilterOnChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }) as P3FilterValues);
  };

  return (
    <>
      <ChartFilterBar
        filters={filterDefs}
        values={filters as unknown as FilterValues}
        onChange={handleFilterChange}
        disabled={loading}
      />
      <LineChartCard
        title="Desajust en el temps en el sector sanitari"
        data={chartData}
        xKey="any"
        lines={lines}
        yLabel="Desajust"
        loading={loading}
        error={error}
      />
      <CompareButton />
    </>
  );
};

export default P3ChartSection;
